export default __webpack_public_path__ + "static/media/a001-01.f77fd805.svg";